import { AttachmentLinkFormDataSchema } from "shared/types/AttachmentLinkFormData"
import { DeepPartialWithNull } from "shared/types/DeepPartial"

import { ClarificationRequestSchema } from "entities/clarification-requests/types/ClarificationRequest"
import { RoomSchema } from "entities/rooms/types/Room"
import z from "zod"

export const RoomFormDataSchema = z.object({
  room: RoomSchema.extend({ id: RoomSchema.shape.id.nullish() }),
  parentID: z.string().nullish(),
  projectID: z.string(),
  displayPosition: z.number(), // Top-level display position
  attachments: AttachmentLinkFormDataSchema.nullish(),
  clarificationRequest: ClarificationRequestSchema.nullish()
})

export type RoomFormState = DeepPartialWithNull<RoomFormData>
export type RoomFormData = z.infer<typeof RoomFormDataSchema>
